import { getCard, shuffle } from '../../shared/index.js';
import { suitEqual } from '../../shared/deck/Deck.js';
import { OhHellCmdType } from './state.js';
export function getSumOfBids(bids) {
    return bids.reduce((sum, bid) => {
        return sum + bid.bidTricks;
    }, 0);
}
export function getPlayerScore(placedBid, previousScore = 0) {
    const score = calculateScore(placedBid.bidTricks, placedBid.wonTricks);
    return {
        ...placedBid,
        roundScore: score,
        netScore: previousScore + score,
    };
}
export function calculateScore(bidTricks, wonTricks) {
    if (bidTricks !== wonTricks) {
        const offBy = Math.abs(bidTricks - wonTricks);
        return (-1 * offBy * (5 + 5 * offBy)) / 2;
    }
    return 10 + bidTricks * bidTricks;
}
export function isOhHellRound(round) {
    return (round &&
        round.deck &&
        Array.isArray(round.players) &&
        Array.isArray(round.hands) &&
        !round.currentRound);
}
export function initRound(deckCode, players, roundNumber, dealerPlayerId) {
    return {
        players: players.filter((player) => !player.didExit),
        dealerPlayerId,
        turnPlayerId: dealerPlayerId,
        deckCode,
        deck: shuffle(deckCode),
        bids: [],
        hands: [],
        roundNumber,
        numberOfCards: roundNumber,
        completedTricks: [],
        roundName: undefined,
        currentTrick: undefined,
        trumpSuit: undefined,
        trumpCard: undefined,
        readyForCommands: [OhHellCmdType.DealCards],
    };
}
export function isReadyForCommand(round, eventType) {
    return round.readyForCommands && round.readyForCommands.includes(eventType);
}
export function isPlayersTurn(round, playerId) {
    return round.turnPlayerId === playerId;
}
export function isTrumpBroken(round) {
    for (let trick of [...round.completedTricks, round.currentTrick]) {
        for (let playedCard of trick?.cards || []) {
            if (suitEqual(round.trumpSuit, getCard(round, playedCard.card).suit)) {
                return true;
            }
        }
    }
    return false;
}
//# sourceMappingURL=round.js.map